import React, {
    useEffect,
    useState,
} from "react";

import axios from "axios";

import {
    FaPlus,
    FaEdit,
    FaTrash,
    FaCheck,
    FaTimes,
    FaImage,
    FaVideo,
    FaStar,
    FaSearch,
} from "react-icons/fa";

import "./GalleryManagement.css";

const API_BASE_URL =
    process.env.REACT_APP_API_URL ||
    "http://localhost:5000";
const token = localStorage.getItem('token');
const initialForm = {
    title: "",
    location: "",
    category: "Safari",
    type: "image",
    video_url: "",
    featured: false,
    status: "active",
    sort_order: 0,
};

function GalleryManagement() {
    const [items, setItems] =
        useState([]);

    const [loading, setLoading] =
        useState(true);

    const [showModal, setShowModal] =
        useState(false);

    const [editingItem, setEditingItem] =
        useState(null);

    const [form, setForm] =
        useState(initialForm);

    const [selectedFile, setSelectedFile] =
        useState(null);

    const [preview, setPreview] =
        useState(null);

    const [search, setSearch] =
        useState("");

    const [statusFilter, setStatusFilter] =
        useState("");

    const fetchGallery = async () => {
        try {
            setLoading(true);

            const response =
                await axios.get(
                    `${API_BASE_URL}/api/gallery/admin/all`,
                    {
                        params: {
                            limit: 100,
                            search,
                            status: statusFilter || undefined,
                        },

                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }

                    }
                );

            setItems(
                response.data.data || []
            );

        } catch (error) {
            console.error(
                "Failed to load gallery:",
                error
            );

            alert(
                "Failed to load gallery items"
            );

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timer =
            setTimeout(() => {
                fetchGallery();
            }, 300);

        return () =>
            clearTimeout(timer);

    }, [
        search,
        statusFilter,
    ]);


    const openCreateModal = () => {
        setEditingItem(null);

        setForm(initialForm);

        setSelectedFile(null);

        setPreview(null);

        setShowModal(true);
    };


    const openEditModal = (item) => {
        setEditingItem(item);

        setForm({
            title: item.title || "",
            location:
                item.location || "",
            category:
                item.category || "General",
            type:
                item.type || "image",
            video_url:
                item.video_url || "",
            featured:
                Boolean(item.featured),
            status:
                item.status || "active",
            sort_order:
                item.sort_order || 0,
        });

        setPreview(
            item.type === "image"
                ? item.image_url
                : item.thumbnail_url
        );

        setSelectedFile(null);

        setShowModal(true);
    };


    const closeModal = () => {
        setShowModal(false);

        setEditingItem(null);

        setForm(initialForm);

        setSelectedFile(null);

        setPreview(null);
    };


    const handleChange = (
        event
    ) => {
        const {
            name,
            value,
            type,
            checked,
        } = event.target;

        setForm((previous) => ({
            ...previous,

            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));
    };


    const handleFileChange = (
        event
    ) => {
        const file =
            event.target.files[0];

        if (!file) return;

        setSelectedFile(file);

        setPreview(
            URL.createObjectURL(file)
        );
    };


    const handleSubmit =
        async (event) => {
            event.preventDefault();

            try {
                const formData =
                    new FormData();

                Object.entries(form).forEach(
                    ([key, value]) => {
                        formData.append(
                            key,
                            value
                        );
                    }
                );

                if (selectedFile) {
                    formData.append(
                        "image",
                        selectedFile
                    );
                }

                if (editingItem) {

                    await axios.put(
                        `${API_BASE_URL}/api/gallery/${editingItem.id}`,
                        formData,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                            }
                        }
                    );

                } else {

                    await axios.post(
                        `${API_BASE_URL}/api/gallery`,
                        formData,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                            }
                        }
                    );
                }

                closeModal();

                fetchGallery();

            } catch (error) {
                console.error(error);

                alert(
                    error.response?.data?.message ||
                    "Something went wrong"
                );
            }
        };


    const toggleStatus =
        async (item) => {
            const newStatus =
                item.status === "active"
                    ? "inactive"
                    : "active";

            try {

                await axios.patch(
                    `${API_BASE_URL}/api/gallery/${item.id}/status`,
                    {
                        status: newStatus,
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                );

                fetchGallery();

            } catch (error) {

                console.error(error);

                alert(
                    "Failed to update status"
                );
            }
        };


    const toggleFeatured =
        async (item) => {
            try {

                await axios.patch(
                    `${API_BASE_URL}/api/gallery/${item.id}/featured`,
                    {
                        featured:
                            !Boolean(
                                item.featured
                            ),

                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                );

                fetchGallery();

            } catch (error) {

                console.error(error);

                alert(
                    "Failed to update featured status"
                );
            }
        };


    const deleteItem =
        async (item) => {

            const confirmed =
                window.confirm(
                    `Delete "${item.title}" permanently?`
                );

            if (!confirmed) return;

            try {

                await axios.delete(
                    `${API_BASE_URL}/api/gallery/${item.id}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );

                fetchGallery();

            } catch (error) {

                console.error(error);

                alert(
                    "Failed to delete gallery item"
                );
            }
        };


    const getMediaUrl = (
        mediaUrl
    ) => {
        if (!mediaUrl) return "";

        if (
            mediaUrl.startsWith(
                "http"
            )
        ) {
            return mediaUrl;
        }

        return `${API_BASE_URL}${mediaUrl}`;
    };


    return (

        <div className="gallery-management">

            {/* HEADER */}

            <div className="gm-header">

                <div>

                    <span>
                        MEDIA MANAGEMENT
                    </span>

                    <h1>
                        Gallery
                        <strong> Management</strong>
                    </h1>

                    <p>
                        Manage your travel photos,
                        videos and experiences.
                    </p>

                </div>


                <button
                    className="gm-add-button"
                    onClick={
                        openCreateModal
                    }
                >

                    <FaPlus />

                    Add Media

                </button>

            </div>


            {/* CONTROLS */}

            <div className="gm-controls">

                <div className="gm-search">

                    <FaSearch />

                    <input
                        placeholder="Search gallery..."
                        value={search}
                        onChange={(event) =>
                            setSearch(
                                event.target.value
                            )
                        }
                    />

                </div>


                <select
                    value={statusFilter}
                    onChange={(event) =>
                        setStatusFilter(
                            event.target.value
                        )
                    }
                >

                    <option value="">
                        All Status
                    </option>

                    <option value="active">
                        Active
                    </option>

                    <option value="inactive">
                        Inactive
                    </option>

                </select>

            </div>


            {/* GRID */}

            {loading ? (

                <div className="gm-loading">
                    Loading gallery...
                </div>

            ) : (

                <div className="gm-grid">

                    {items.map((item) => {

                        const media =
                            item.type === "image"
                                ? item.image_url
                                : item.thumbnail_url;

                        return (

                            <div
                                className={`gm-card ${item.status ===
                                    "inactive"
                                    ? "inactive"
                                    : ""
                                    }`}
                                key={item.id}
                            >

                                <div className="gm-image">

                                    {media ? (

                                        <img
                                            src={
                                                getMediaUrl(
                                                    media
                                                )
                                            }
                                            alt={
                                                item.title
                                            }
                                        />

                                    ) : (

                                        <div className="gm-no-image">

                                            <FaVideo />

                                        </div>

                                    )}


                                    <div className="gm-badges">

                                        <span>
                                            {item.type ===
                                                "video"
                                                ? <FaVideo />
                                                : <FaImage />
                                            }

                                            {item.type}
                                        </span>


                                        {item.featured === 1 && (

                                            <span className="featured">

                                                <FaStar />

                                                Featured

                                            </span>

                                        )}

                                    </div>

                                </div>


                                <div className="gm-content">

                                    <h3>
                                        {item.title}
                                    </h3>

                                    <p>
                                        {item.location ||
                                            "No location"}
                                    </p>

                                    <small>
                                        {item.category}
                                    </small>


                                    <div className="gm-status">

                                        <span
                                            className={
                                                item.status
                                            }
                                        >

                                            {item.status ===
                                                "active"
                                                ? <FaCheck />
                                                : <FaTimes />
                                            }

                                            {item.status}

                                        </span>

                                    </div>


                                    <div className="gm-actions">

                                        <button
                                            onClick={() =>
                                                openEditModal(
                                                    item
                                                )
                                            }
                                            title="Edit"
                                        >

                                            <FaEdit />

                                        </button>


                                        <button
                                            onClick={() =>
                                                toggleFeatured(
                                                    item
                                                )
                                            }
                                            className={
                                                item.featured ===
                                                    1
                                                    ? "active-star"
                                                    : ""
                                            }
                                            title="Featured"
                                        >

                                            <FaStar />

                                        </button>


                                        <button
                                            onClick={() =>
                                                toggleStatus(
                                                    item
                                                )
                                            }
                                            title={
                                                item.status ===
                                                    "active"
                                                    ? "Deactivate"
                                                    : "Activate"
                                            }
                                        >

                                            {item.status ===
                                                "active"
                                                ? <FaTimes />
                                                : <FaCheck />
                                            }

                                        </button>


                                        <button
                                            className="delete"
                                            onClick={() =>
                                                deleteItem(
                                                    item
                                                )
                                            }
                                            title="Delete"
                                        >

                                            <FaTrash />

                                        </button>

                                    </div>

                                </div>

                            </div>

                        );
                    })}

                </div>

            )}


            {/* MODAL */}

            {showModal && (

                <div
                    className="gm-modal"
                    onClick={closeModal}
                >

                    <div
                        className="gm-modal-content"
                        onClick={(event) =>
                            event.stopPropagation()
                        }
                    >

                        <button
                            className="gm-close"
                            onClick={closeModal}
                        >

                            <FaTimes />

                        </button>


                        <h2>

                            {editingItem
                                ? "Edit Gallery Item"
                                : "Add Gallery Item"
                            }

                        </h2>


                        <form
                            onSubmit={
                                handleSubmit
                            }
                        >

                            <div className="gm-form-grid">

                                <div className="gm-form-group full">

                                    <label>
                                        Title *
                                    </label>

                                    <input
                                        name="title"
                                        value={form.title}
                                        onChange={
                                            handleChange
                                        }
                                        required
                                    />

                                </div>


                                <div className="gm-form-group">

                                    <label>
                                        Media Type
                                    </label>

                                    <select
                                        name="type"
                                        value={form.type}
                                        onChange={
                                            handleChange
                                        }
                                    >

                                        <option value="image">
                                            Image
                                        </option>

                                        <option value="video">
                                            Video
                                        </option>

                                    </select>

                                </div>


                                <div className="gm-form-group">

                                    <label>
                                        Category
                                    </label>

                                    <input
                                        name="category"
                                        value={
                                            form.category
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />

                                </div>


                                <div className="gm-form-group">

                                    <label>
                                        Location
                                    </label>

                                    <input
                                        name="location"
                                        value={
                                            form.location
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />

                                </div>


                                <div className="gm-form-group">

                                    <label>
                                        Sort Order
                                    </label>

                                    <input
                                        type="number"
                                        name="sort_order"
                                        value={
                                            form.sort_order
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />

                                </div>


                                {form.type ===
                                    "video" && (

                                        <div className="gm-form-group full">

                                            <label>
                                                Video URL *
                                            </label>

                                            <input
                                                type="url"
                                                name="video_url"
                                                value={
                                                    form.video_url
                                                }
                                                onChange={
                                                    handleChange
                                                }
                                                required
                                            />

                                        </div>

                                    )}


                                <div className="gm-form-group full">

                                    <label>

                                        {form.type ===
                                            "video"
                                            ? "Video Thumbnail"
                                            : "Image"
                                        }

                                    </label>

                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={
                                            handleFileChange
                                        }
                                    />

                                </div>


                                {preview && (

                                    <div className="gm-preview full">

                                        <img
                                            src={
                                                getMediaUrl(
                                                    preview
                                                )
                                            }
                                            alt="Preview"
                                        />

                                    </div>

                                )}

                            </div>


                            <div className="gm-checkboxes">

                                <label>

                                    <input
                                        type="checkbox"
                                        name="featured"
                                        checked={
                                            form.featured
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />

                                    Featured

                                </label>


                                <label>

                                    <input
                                        type="checkbox"
                                        checked={
                                            form.status ===
                                            "active"
                                        }
                                        onChange={(event) =>
                                            setForm(
                                                (
                                                    previous
                                                ) => ({
                                                    ...previous,

                                                    status:
                                                        event
                                                            .target
                                                            .checked
                                                            ? "active"
                                                            : "inactive",
                                                })
                                            )
                                        }
                                    />

                                    Active

                                </label>

                            </div>


                            <div className="gm-modal-actions">

                                <button
                                    type="button"
                                    onClick={closeModal}
                                    className="cancel"
                                >
                                    Cancel
                                </button>


                                <button
                                    type="submit"
                                    className="save"
                                >

                                    {editingItem
                                        ? "Update Item"
                                        : "Upload Item"
                                    }

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}

        </div>
    );
}

export default GalleryManagement;